/// <amd-module name="Test/TestPlansHubRefresh/Pivots/ExecutePivot/Redux/PointsModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { ActionsUnion } from "redux/Utils/ActionHelper";
import { PointsActions } from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/Redux/PointsActions";
import { IPointsAwareState, ITestPointItem } from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/Redux/PointsContracts";
import { PointsFilterReducer } from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/Redux/PointsFilterReducer";
import { PointsReducer } from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/Redux/PointsReducer";
import { PointsSaga } from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/Redux/PointsSaga";
import { TestHubRefreshReducer } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshReducer";
import { testHubRefreshLocalContextData } from "Test/TestPlansHubRefresh/TestHub/Utils/TestPlansHubRefreshLocalContextProvider";

export function getPointsModule(
    planId: number,
    suiteId: number,
    points: ITestPointItem[],
    initialSelectedSuiteId: number,
    isShowTestsFromChildSuitesEnabled: boolean
): ISagaModule<IPointsAwareState> {
    const initialActions: ActionsUnion<typeof PointsActions>[] = [];
    initialActions.push(PointsActions.initializeExecutePivot(), PointsActions.updateAssignTesterDropdownState(true));

    if (!points || points.length == 0) {
        // since loadInitialTestPoints loads the data from json island, fire it only if the json island data is not dirty/stale
        if (!isShowTestsFromChildSuitesEnabled && initialSelectedSuiteId === suiteId && !testHubRefreshLocalContextData.isJsonIslandDataDirty()) {
            initialActions.push(PointsActions.loadInitialTestPoints());
        } else {
            initialActions.push(PointsActions.loadTestPointsForSelectedSuite(planId, suiteId));
        }
    }

    return {
        id: "points",
        reducerMap: {
            executeState: PointsReducer,
            testHubRefreshState: TestHubRefreshReducer,
            executeFilterState: PointsFilterReducer
        },
        sagas: [PointsSaga],
        initialActions: initialActions
    };
}
